import DescriptionDetails from "components/DescriptionDetails";
import FormFieldTimestamp from "components/FormFields/Timestamp";
import FormFieldViewText from "components/FormFields/ViewText";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import FormField from "ds/components/Form/Field";
import { useShowFullDescriptionWithBackArrow } from "ds/components/FullDescriptionDrawer/useShowFullDescriptionWithBackArrow";
import Typography from "ds/components/Typography";
import { ApiKey } from "types/generated";
import ApiKeyExpiresAt from "views/Account/Settings/ApiKey/components/ExpiresAt";

type PersonalSettingsApiKeysDetailsDrawerProps = {
  apiKey: Pick<ApiKey, "id" | "name" | "lastUsedAt" | "expiresAt" | "description">;
};

const PersonalSettingsApiKeysDetailsDrawer = createDrawer(
  ({ apiKey }: PersonalSettingsApiKeysDetailsDrawerProps) => {
    const onOpenFullDescription = useShowFullDescriptionWithBackArrow(apiKey.description);

    return (
      <DrawerSimple isDismissable>
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="API key details" />
          <DrawerCloseIcon />
        </DrawerHeader>
        <DrawerBody>
          <FormFieldViewText label="Name" value={apiKey.name} />
          <FormFieldViewText label="Key ID" value={apiKey.id} withCopy />
          {apiKey.lastUsedAt && (
            <FormFieldTimestamp label="Last used" timestamp={apiKey.lastUsedAt} />
          )}
          {!apiKey.lastUsedAt && (
            <FormField label="Last used">
              <Typography tag="span" variant="p-body3">
                Never used
              </Typography>
            </FormField>
          )}
          <FormField label="Expires at" align="start">
            <ApiKeyExpiresAt expiresAt={apiKey.expiresAt} />
          </FormField>
          <DescriptionDetails
            description={apiKey.description}
            onOpenFullDescription={onOpenFullDescription}
          />
        </DrawerBody>
      </DrawerSimple>
    );
  }
);

export const showPersonalSettingsApiKeysDetailsDrawer = createDrawerTrigger(
  PersonalSettingsApiKeysDetailsDrawer
);
